import { useState, useRef, useEffect } from "react";

// Three church videos side-by-side as a muted, looping hero background.
// Each clip fades in once it can play, for a smooth, polished entrance.
const VIDEOS = [
  "https://customer-assets.emergentagent.com/job_glowing-grace-chapel/artifacts/km2hggbi_Snippets%20from%20Anointing%20service%20on%20our%20Covenant%20Family%20Day.%20%23anointingservice%20%23covenantfamilyday.mp4",
  "https://customer-assets.emergentagent.com/job_glowing-grace-chapel/artifacts/qseqlpf8_Say%20a%20resounding%20Amen.%23winnerschapelcolchester%20%23church%20%23colchester%20%23prayer%20%23newweek.mp4",
  "https://customer-assets.emergentagent.com/job_glowing-grace-chapel/artifacts/yqa8ucfx_Happy%20Easter%21%23eastersunday%20%23easter%20%23sundayservice%20%23winnerschapelinternational%20%23winnerschapelcolc.mp4",
];

export default function HeroVideos() {
  const [ready, setReady] = useState({});
  const refs = useRef([]);

  // React doesn't reliably set the `muted` DOM property, which makes iOS/Chrome
  // block autoplay and show a native play button. Set it imperatively and kick off play.
  useEffect(() => {
    refs.current.forEach((v) => {
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      const p = v.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    });
  }, []);

  return (
    <div className="absolute inset-0 grid grid-cols-3" aria-hidden="true">
      {VIDEOS.map((src, i) => (
        <video
          key={i}
          ref={(el) => (refs.current[i] = el)}
          src={src}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          controls={false}
          disablePictureInPicture
          disableRemotePlayback
          x-webkit-airplay="deny"
          onLoadedData={(e) => {
            e.currentTarget.muted = true;
            const p = e.currentTarget.play();
            if (p && typeof p.catch === "function") p.catch(() => {});
            setReady((r) => ({ ...r, [i]: true }));
          }}
          style={{
            transition: "opacity 1s ease",
            opacity: ready[i] ? 1 : 0,
            willChange: "opacity",
            pointerEvents: "none",
          }}
          className="w-full h-full object-cover transform-gpu"
        />
      ))}
      {/* Soften the seams between the three clips */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(90deg, transparent 30%, rgba(0,0,0,0.45) 33.3%, transparent 36%, transparent 64%, rgba(0,0,0,0.45) 66.6%, transparent 70%)",
        }}
      />
    </div>
  );
}
